export class Logo {
  constructor(
    public id: string,
    public url: string,
    public logoType: string
  ) {}
}